import {URLPAGINA} from "../../Constantes";

export const irFunnel = ({entidad}) => {

    console.log(entidad)
    let nombre = encodeURIComponent(entidad.id)
    let link = URLPAGINA + '?id=' + nombre + '&idUsu=global_gmail-com'

    window.open(link, '_blank');

}